/* tslint:disable */
/* eslint-disable */
/**
 * Customer API v2
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.3.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CustomerItxNotificationDto
 */
export interface CustomerItxNotificationDto {
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxNotificationDto
     */
    'itemFavorite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxNotificationDto
     */
    'itemPaused'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxNotificationDto
     */
    'itemSold'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerItxNotificationDto
     */
    'iconNotification'?: boolean;
}

/**
 * CustomerAPIV2Api - axios parameter creator
 * @export
 */
export const CustomerAPIV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNotifications: async (storeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCustomerNotifications', 'storeId', storeId)
            const localVarPath = `/api/v2/customer/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION'} notificationType 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationViewed: async (notificationType: 'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION', storeId: number, productId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationType' is not null or undefined
            assertParamExists('notificationViewed', 'notificationType', notificationType)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('notificationViewed', 'storeId', storeId)
            const localVarPath = `/api/v2/customer/{notificationType}/viewed`
                .replace(`{${"notificationType"}}`, encodeURIComponent(String(notificationType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerAPIV2Api - functional programming interface
 * @export
 */
export const CustomerAPIV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerAPIV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerNotifications(storeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItxNotificationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerNotifications(storeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION'} notificationType 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationViewed(notificationType: 'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION', storeId: number, productId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationViewed(notificationType, storeId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerAPIV2Api - factory interface
 * @export
 */
export const CustomerAPIV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerAPIV2ApiFp(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerNotifications(storeId: number, options?: any): AxiosPromise<CustomerItxNotificationDto> {
            return localVarFp.getCustomerNotifications(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION'} notificationType 
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [productId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationViewed(notificationType: 'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION', storeId: number, productId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.notificationViewed(notificationType, storeId, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerAPIV2Api - interface
 * @export
 * @interface CustomerAPIV2Api
 */
export interface CustomerAPIV2ApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAPIV2ApiInterface
     */
    getCustomerNotifications(storeId: number, options?: AxiosRequestConfig): AxiosPromise<CustomerItxNotificationDto>;

    /**
     * 
     * @param {'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION'} notificationType 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAPIV2ApiInterface
     */
    notificationViewed(notificationType: 'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION', storeId: number, productId?: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * CustomerAPIV2Api - object-oriented interface
 * @export
 * @class CustomerAPIV2Api
 * @extends {BaseAPI}
 */
export class CustomerAPIV2Api extends BaseAPI implements CustomerAPIV2ApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAPIV2Api
     */
    public getCustomerNotifications(storeId: number, options?: AxiosRequestConfig) {
        return CustomerAPIV2ApiFp(this.configuration).getCustomerNotifications(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION'} notificationType 
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [productId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAPIV2Api
     */
    public notificationViewed(notificationType: 'ITEM_SOLD' | 'ITEM_FAVORITE' | 'ITEM_PAUSED' | 'ICON_NOTIFICATION', storeId: number, productId?: number, options?: AxiosRequestConfig) {
        return CustomerAPIV2ApiFp(this.configuration).notificationViewed(notificationType, storeId, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


